export default __webpack_public_path__ + "static/media/mpr.8523302b.png";